
// import axiosClient from '../axiosClient';

// // Get the API URL from the same source as axiosClient
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// export const invoiceHeaderApi = {
//   getInvoiceHeaders: async (page = 0, size = 20, search = '', month = '', status = '', sortBy = '', sortOrder = 'desc') => {
//     try {
//       const params = new URLSearchParams({
//         page: page.toString(),
//         size: size.toString(),
//       });

//       if (search && search.trim() !== '') {
//         params.append('search', search.trim());
//       }

//       if (month && month.trim() !== '') {
//         params.append('month', month.trim());
//       }

//       if (status && status.trim() !== '') {
//         params.append('status', status.trim());
//       }

//       if (sortBy && sortBy.trim() !== '') {
//         params.append('sortBy', sortBy.trim());
//         params.append('sortOrder', sortOrder);
//       }

//       console.log('📦 Fetching invoice headers with params:', params.toString());

//       const data = await axiosClient.get(`/invoice-headers?${params.toString()}`);
      
//       console.log('📦 Invoice Headers API data:', data);
      
//       return data;
//     } catch (error) {
//       console.error('Error fetching invoice headers:', error);
//       throw error;
//     }
//   },

//   exportInvoiceHeaders: async (search = '', month = '', status = '') => {
//     try {
//       const params = new URLSearchParams();
      
//       if (search && search.trim() !== '') {
//         params.append('search', search.trim());
//       }

//       if (month && month.trim() !== '') {
//         params.append('month', month.trim());
//       }

//       if (status && status.trim() !== '') {
//         params.append('status', status.trim());
//       }

//       console.log('📊 Exporting invoice headers with params:', params.toString());

//       const data = await axiosClient.get(`/invoice-headers/export?${params.toString()}`);
//       return data;
//     } catch (error) {
//       console.error('Error exporting invoice headers:', error);
//       throw error;
//     }
//   },

//   getInvoiceDetails: async (invoiceNum) => {
//     try {
//       console.log('🔍 Fetching invoice details for:', invoiceNum);
//       const data = await axiosClient.get(`/invoice-headers/${invoiceNum}`);
//       return data;
//     } catch (error) {
//       console.error('Error fetching invoice details:', error);
//       throw error;
//     }
//   },

//   checkPdfExists: async (docNum) => {
//     try {
//       console.log('═══════════════════════════════════════');
//       console.log('🔍 Checking if PDF exists for:', docNum);
      
//       const response = await axiosClient.get(`/invoice/check-pdf/${docNum}`);
      
//       console.log('✅ RAW RESPONSE:', response);
//       console.log('Response type:', typeof response);
      
//       // The response from axiosClient is already the data
//       // So response should be { docNum: "xxx", exists: true/false }
      
//       let exists = false;
      
//       if (response && typeof response === 'object') {
//         if ('exists' in response) {
//           exists = response.exists === true;
//           console.log('✓ Found exists directly:', exists);
//         } else if (response.data && 'exists' in response.data) {
//           exists = response.data.exists === true;
//           console.log('✓ Found exists in response.data:', exists);
//         }
//       }
      
//       console.log(`📄 FINAL - PDF exists for ${docNum}:`, exists);
//       console.log('═══════════════════════════════════════\n');
      
//       return { exists };
//     } catch (error) {
//       console.error('❌ Error checking PDF for', docNum, ':', error);
//       return { exists: false };
//     }
//   },

//   downloadInvoicePdf: async (docNum) => {
//     try {
//       console.log('📥 Downloading PDF for:', docNum);
//       console.log('🌍 Using API URL:', API_URL);
      
//       // Get auth token
//       const authToken = localStorage.getItem('auth_token') || 
//                        sessionStorage.getItem('auth_token');
      
//       if (!authToken) {
//         throw new Error('No authentication token found');
//       }

//       // Use the same API_URL as axiosClient
//       const downloadUrl = `${API_URL}/api/invoice/download-pdf/${docNum}`;
//       console.log('📥 Download URL:', downloadUrl);

//       const response = await fetch(downloadUrl, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//         },
//         credentials: 'include',
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error('❌ Download failed:', errorText);
//         throw new Error(`Failed to download PDF: ${response.status} - ${errorText}`);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Invoice_${docNum}(Signed).pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
      
//       console.log('✅ PDF downloaded successfully');
//     } catch (error) {
//       console.error('❌ Error downloading PDF:', error);
//       throw error;
//     }
//   },
// };

import axiosClient from '../axiosClient';

// Get the API URL from the same source as axiosClient
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const invoiceHeaderApi = {
  getInvoiceHeaders: async (page = 0, size = 20, search = '', month = '', status = '', sortBy = '', sortOrder = 'desc', year = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      if (year && year.toString().trim() !== '') {
        params.append('year', year.toString().trim());
      }

      if (sortBy && sortBy.trim() !== '') {
        params.append('sortBy', sortBy.trim());
        params.append('sortOrder', sortOrder);
      }

      console.log('📦 Fetching invoice headers with params:', params.toString());

      const data = await axiosClient.get(`/invoice-headers?${params.toString()}`);

      console.log('📦 Invoice Headers API data:', data);

      return data;
    } catch (error) {
      console.error('Error fetching invoice headers:', error);
      throw error;
    }
  },

  exportInvoiceHeaders: async (search = '', month = '', status = '', year = '') => {
    try {
      const params = new URLSearchParams();

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      if (year && year.toString().trim() !== '') {
        params.append('year', year.toString().trim());
      }

      console.log('📊 Exporting invoice headers with params:', params.toString());

      const data = await axiosClient.get(`/invoice-headers/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting invoice headers:', error);
      throw error;
    }
  },

  getInvoiceDetails: async (invoiceNum) => {
    try {
      console.log('🔍 Fetching invoice details for:', invoiceNum);
      const data = await axiosClient.get(`/invoice-headers/${invoiceNum}`);
      return data;
    } catch (error) {
      console.error('Error fetching invoice details:', error);
      throw error;
    }
  },

  getInvoiceYears: async () => {
    try {
      console.log('📅 Fetching available invoice years...');
      const data = await axiosClient.get(`/invoice-headers/years`);
      console.log('📅 Available years:', data);
      return data;
    } catch (error) {
      console.error('Error fetching invoice years:', error);
      throw error;
    }
  },

  checkPdfExists: async (docNum) => {
    try {
      console.log('═══════════════════════════════════════');
      console.log('🔍 Checking if PDF exists for:', docNum);

      const response = await axiosClient.get(`/invoice/check-pdf/${docNum}`);

      console.log('✅ RAW RESPONSE:', response);
      console.log('Response type:', typeof response);

      let exists = false;

      if (response && typeof response === 'object') {
        if ('exists' in response) {
          exists = response.exists === true;
          console.log('✓ Found exists directly:', exists);
        } else if (response.data && 'exists' in response.data) {
          exists = response.data.exists === true;
          console.log('✓ Found exists in response.data:', exists);
        }
      }

      console.log(`📄 FINAL - PDF exists for ${docNum}:`, exists);
      console.log('═══════════════════════════════════════\n');

      return { exists };
    } catch (error) {
      console.error('❌ Error checking PDF for', docNum, ':', error);
      return { exists: false };
    }
  },

  downloadInvoicePdf: async (docNum) => {
    try {
      console.log('📥 Downloading PDF for:', docNum);
      console.log('🌍 Using API URL:', API_URL);

      // Get auth token
      const authToken = localStorage.getItem('auth_token') ||
                       sessionStorage.getItem('auth_token');

      if (!authToken) {
        throw new Error('No authentication token found');
      }

      // Use the same API_URL as axiosClient
      const downloadUrl = `${API_URL}/api/invoice/download-pdf/${docNum}`;
      console.log('📥 Download URL:', downloadUrl);

      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
        credentials: 'include',
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Download failed:', errorText);
        throw new Error(`Failed to download PDF: ${response.status} - ${errorText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Invoice_${docNum}(Signed).pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log('✅ PDF downloaded successfully');
    } catch (error) {
      console.error('❌ Error downloading PDF:', error);
      throw error;
    }
  },
};